import { Navigate, Route } from "react-router";
import { all_routes } from "./all_routes";
import Countries from "../content/location/countries";
import BlankPage from "../pages/blankPage";
import Calendar from "../mainMenu/apps/calendar";
import DataTable from "../tables/dataTable";
import BasicTable from "../tables/basicTable";
import DeleteRequest from "../userManagement/deleteRequest";
import Membershipplan from "../membership/membershipplan";
import MembershipAddon from "../membership/membershipaddon";
import Notes from "../application/notes";
import ComingSoon from "../pages/comingSoon";
import Login from "../auth/login/login";
import Register from "../auth/register/register";
import TwoStepVerification from "../auth/twoStepVerification/twoStepVerification";
import EmailVerification from "../auth/emailVerification/emailVerification";
import ResetPassword from "../auth/resetPassword/resetPassword";
import ForgotPassword from "../auth/forgotPassword/forgotPassword";
import Accordion from "../uiInterface/base-ui/accordion";
import Avatar from "../uiInterface/base-ui/avatar";
import Borders from "../uiInterface/base-ui/borders";
import Breadcrumb from "../uiInterface/base-ui/breadcrumb";
import Buttons from "../uiInterface/base-ui/buttons";
import ButtonsGroup from "../uiInterface/base-ui/buttonsgroup";
import Cards from "../uiInterface/base-ui/cards";
import Carousel from "../uiInterface/base-ui/carousel";
import Colors from "../uiInterface/base-ui/colors";
import Dropdowns from "../uiInterface/base-ui/dropdowns";
import Grid from "../uiInterface/base-ui/grid";
import Images from "../uiInterface/base-ui/images";
import Lightboxes from "../uiInterface/base-ui/lightbox";
import Media from "../uiInterface/base-ui/media";
import Modals from "../uiInterface/base-ui/modals";
import NavTabs from "../uiInterface/base-ui/navtabs";
import Offcanvas from "../uiInterface/base-ui/offcanvas";
import Pagination from "../uiInterface/base-ui/pagination";
import Popovers from "../uiInterface/base-ui/popover";
import RangeSlides from "../uiInterface/base-ui/rangeslider";
import Progress from "../uiInterface/base-ui/progress";
import Spinner from "../uiInterface/base-ui/spinner";
import Toasts from "../uiInterface/base-ui/toasts";
import Typography from "../uiInterface/base-ui/typography";
import Video from "../uiInterface/base-ui/video";
import Error404 from "../pages/error/error-404";
import Error500 from "../pages/error/error-500";
import Preference from "../settings/websiteSettings/preference";
import UnderMaintenance from "../pages/underMaintenance";
import Todo from "../application/todo";
import Email from "../application/email";
import Chat from "../application/chat";
import Pages from "../content/pages";
import AudioCall from "../application/call/audioCall";
import CallHistory from "../application/call/callHistory";
import FileManager from "../application/fileManager";
import MembershipTransaction from "../membership/membershiptrasaction";
import ClipBoard from "../uiInterface/advanced-ui/clipboard";
import Counter from "../uiInterface/advanced-ui/counter";
import DragAndDrop from "../uiInterface/advanced-ui/dragdrop";
import Rating from "../uiInterface/advanced-ui/rating";
import Stickynote from "../uiInterface/advanced-ui/stickynote";
import TextEditor from "../uiInterface/advanced-ui/texteditor";
import Timeline from "../uiInterface/advanced-ui/timeline";
import Scrollbar from "../uiInterface/advanced-ui/uiscrollbar";
import Apexchart from "../uiInterface/charts/apexcharts";
import FeatherIcons from "../uiInterface/icons/feathericon";
import FontawesomeIcons from "../uiInterface/icons/fontawesome";
import MaterialIcons from "../uiInterface/icons/materialicon";
import PE7Icons from "../uiInterface/icons/pe7icons";
import SimplelineIcons from "../uiInterface/icons/simplelineicon";
import ThemifyIcons from "../uiInterface/icons/themify";
import TypiconIcons from "../uiInterface/icons/typicons";
import WeatherIcons from "../uiInterface/icons/weathericons";
import BasicInputs from "../uiInterface/forms/formelements/basic-inputs";
import CheckboxRadios from "../uiInterface/forms/formelements/checkbox-radios";
import InputGroup from "../uiInterface/forms/formelements/input-group";
import GridGutters from "../uiInterface/forms/formelements/grid-gutters";
import FormSelect from "../uiInterface/forms/formelements/form-select";
import FormMask from "../uiInterface/forms/formelements/form-mask";
import FileUpload from "../uiInterface/forms/formelements/fileupload";
import FormHorizontal from "../uiInterface/forms/formelements/layouts/form-horizontal";
import FormVertical from "../uiInterface/forms/formelements/layouts/form-vertical";
import FloatingLabel from "../uiInterface/forms/formelements/layouts/floating-label";
import FormValidation from "../uiInterface/forms/formelements/layouts/form-validation";
import FormSelect2 from "../uiInterface/forms/formelements/layouts/form-select2";
import FormWizard from "../uiInterface/forms/formelements/form-wizard";
import DataTables from "../uiInterface/table/data-tables";
import TablesBasic from "../uiInterface/table/tables-basic";
import IonicIcons from "../uiInterface/icons/ionicicons";
import Badges from "../uiInterface/base-ui/badges";
import Placeholder from "../uiInterface/base-ui/placeholder";
import Alert from "../uiInterface/base-ui/alert";
import Tooltips from "../uiInterface/base-ui/tooltips";
import Ribbon from "../uiInterface/advanced-ui/ribbon";
import AdminDashboard from "../mainMenu/adminDashboard";
import AlertUi from "../uiInterface/base-ui/alert-ui";
import TeacherDashboard from "../mainMenu/teacherDashboard";
import StudentDasboard from "../mainMenu/studentDashboard";
import ParentDashboard from "../mainMenu/parentDashboard";
import StudentGrid from "../peoples/students/student-grid";
import AddStudent from "../peoples/students/add-student";
import StudentList from "../peoples/students/student-list";
import StudentLibrary from "../peoples/students/student-details/studentLibrary";
import StudentDetails from "../peoples/students/student-details/studentDetails";
import StudentFees from "../peoples/students/student-details/studentFees";
import StudentLeaves from "../peoples/students/student-details/studentLeaves";
import StudentResult from "../peoples/students/student-details/studentResult";
import StudentTimeTable from "../peoples/students/student-details/studentTimeTable";
import AcademicReason from "../academic/academic-reason";
import ClassSyllabus from "../academic/class-syllabus";
import ClassSubject from "../academic/class-subject";
import ClassSection from "../academic/class-section";
import ClassRoom from "../academic/class-room";
import ClassRoutine from "../academic/class-routine";
import ScheduleClasses from "../academic/schedule-classes";
import Exam from "../academic/examinations/exam";
import ExamSchedule from "../academic/examinations/exam-schedule";
import Grade from "../academic/examinations/grade";
import Staff from "../hrm/staff-list/staff";
import Departments from "../hrm/departments";
import Classes from "../academic/classes";
import ClassHomeWork from "../academic/class-home-work";
import ExamResult from "../academic/examinations/exam-results";
import ExamAttendance from "../academic/examinations/exam-attendance";
import StudentPromotion from "../peoples/students/student-promotion";
import TeacherGrid from "../peoples/teacher/teacher-grid";
import TeacherForm from "../peoples/teacher/teacherForm";
import ClassTimetable from "../academic/class-timetable";
import Payroll from "../hrm/payroll";
import Holiday from "../hrm/holidays";
import Designation from "../hrm/designation";
import ListLeaves from "../hrm/leaves/list-leaves";
import StaffDetails from "../hrm/staff-list/staff-details.tsx";
import StaffPayRoll from "../hrm/staff-list/staff-payroll.tsx";
import StaffLeave from "../hrm/staff-list/staff-leave";
import ApproveRequest from "../hrm/leaves/approve-request";
import TeacherList from "../peoples/teacher/teacher-list";
import TeacherDetails from "../peoples/teacher/teacher-details/teacherDetails";
import TeachersRoutine from "../peoples/teacher/teacher-details/teachersRoutine";
import TeacherSalary from "../peoples/teacher/teacher-details/teacherSalary";
import TeacherLeave from "../peoples/teacher/teacher-details/teacherLeave";
import TeacherLibrary from "../peoples/teacher/teacher-details/teacherLibrary";
import ParentGrid from "../peoples/parent/parent-grid";
import ParentList from "../peoples/parent/parent-list";
import GuardianGrid from "../peoples/guardian/guardian-grid";
import GuardianList from "../peoples/guardian/guardian-list";
import FeesGroup from "../management/feescollection/feesGroup";
import Login2 from "../auth/login/login-2";
import Login3 from "../auth/login/login-3";
import ResetPassword2 from "../auth/resetPassword/resetPassword-2";
import ResetPassword3 from "../auth/resetPassword/resetPassword-3";
import TwoStepVerification2 from "../auth/twoStepVerification/twoStepVerification-2";
import TwoStepVerification3 from "../auth/twoStepVerification/twoStepVerification-3";
import Register2 from "../auth/register/register-2";
import Register3 from "../auth/register/register-3";
import ForgotPassword2 from "../auth/forgotPassword/forgotPassword-2";
import ForgotPassword3 from "../auth/forgotPassword/forgotPassword-3";
import ResetPasswordSuccess from "../auth/resetPasswordSuccess/resetPasswordSuccess";
import ResetPasswordSuccess2 from "../auth/resetPasswordSuccess/resetPasswordSuccess-2";
import ResetPasswordSuccess3 from "../auth/resetPasswordSuccess/resetPasswordSuccess-3";
import FeesTypes from "../management/feescollection/feesTypes";
import FeesMaster from "../management/feescollection/feesMaster";
import FeesAssign from "../management/feescollection/feesAssign";
import CollectFees from "../management/feescollection/collectFees";
import StudentAttendance from "../hrm/attendance/student-attendance";
import TeacherAttendance from "../hrm/attendance/teacher-attendance";
import StaffAttendance from "../hrm/attendance/staff-attendance";
import AddStaff from "../hrm/staff-list/add-staff";
import EditStaff from "../hrm/staff-list/edit-staff";
import StaffsAttendance from "../hrm/staff-list/staffs-attendance";
import LibraryMember from "../management/library/libraryMember";
import Books from "../management/library/books";
import IssueBook from "../management/library/issuesBook";
import ReturnBook from "../management/library/returnBook";
import SportsList from "../management/sports/sportsList";
import PlayersList from "../management/sports/playersList";
import HostelRooms from "../management/hostel/hostelRooms";
import HostelList from "../management/hostel/hostelList";
import HostelType from "../management/hostel/hostelType";
import TransportRoutes from "../management/transport/transportRoutes";
import TransportPickupPoints from "../management/transport/transportPickupPoints";
import TransportVehicleDrivers from "../management/transport/transportVehicleDrivers";
import TransportVehicle from "../management/transport/transportVehicle";
import TransportAssignVehicle from "../management/transport/transportAssignVehicle";
import RolesPermissions from "../userManagement/rolesPermissions";
import Permission from "../userManagement/permission";
import Manageusers from "../userManagement/manageusers";
import Profilesettings from "../settings/generalSettings/profile";
import Securitysettings from "../settings/generalSettings/security";
import Notificationssettings from "../settings/generalSettings/notifications";
import ConnectedApps from "../settings/generalSettings/connectedApps";
import CompanySettings from "../settings/websiteSettings/companySettings";
import Localization from "../settings/websiteSettings/localization";
import Prefixes from "../settings/websiteSettings/prefixes";
import Socialauthentication from "../settings/websiteSettings/socialAuthentication";
import Languagesettings from "../settings/websiteSettings/language";
import InvoiceSettings from "../settings/appSettings/invoiceSettings";
import CustomFields from "../settings/appSettings/customFields";
import EmailSettings from "../settings/systemSettings/emailSettings";
import Emailtemplates from "../settings/systemSettings/email-templates";
import SmsSettings from "../settings/systemSettings/smsSettings";
import OtpSettings from "../settings/systemSettings/otp-settings";
import GdprCookies from "../settings/systemSettings/gdprCookies";
import PaymentGateways from "../settings/financialSettings/paymentGateways";
import TaxRates from "../settings/financialSettings/taxRates";
import SchoolSettings from "../settings/academicSettings/schoolSettings";
import Religion from "../settings/academicSettings/religion";
import Storage from "../settings/otherSettings/storage";
import BanIpAddress from "../settings/otherSettings/banIpaddress";
import AllBlogs from "../content/blog/allBlogs";
import BlogCategories from "../content/blog/blogCategories";
import BlogComments from "../content/blog/blogComments";
import BlogTags from "../content/blog/blogTags";
import Faq from "../content/faq";
import Cities from "../content/location/cities";
import States from "../content/location/states";
import Testimonials from "../content/testimonials";
import AccountsIncome from "../accounts/accounts-income";
import AccountsInvoices from "../accounts/accounts-invoices";
import AccountsTransactions from "../accounts/accounts-transactions";
import AddInvoice from "../accounts/add-invoice";
import EditInvoice from "../accounts/edit-invoice";
import Expense from "../accounts/expense";
import ExpensesCategory from "../accounts/expenses-category";
import Invoice from "../accounts/invoice";
import NoticeBoard from "../announcements/notice-board";
import Tickets from "../support/tickets";
import TicketGrid from "../support/ticket-grid";
import TicketDetails from "../support/ticket-details";
import FeesReport from "../report/fees-report/feesReport";
import LeaveReport from "../report/leave-report/leaveReport";
import GradeReport from "../report/grade-report/gradeReport";
import StudentReport from "../report/student-report/studentReport";
import ClassReport from "../report/class-report/classReport";
import AttendanceReport from "../report/attendance-report/attendanceReport";
import ContactMessages from "../support/contactMessages";
import Events from "../announcements/events";
import Profile from "../pages/profile";
import StudentAttendanceType from "../report/attendance-report/studentAttendanceType";
import StaffReport from "../report/attendance-report/staffReport";
import TeacherReport from "../report/attendance-report/teacherReport";
import StaffDayWise from "../report/attendance-report/staffDayWise";
import TeacherDayWise from "../report/attendance-report/teacherDayWise";
import StudentDayWise from "../report/attendance-report/studentDayWise";
import DailyAttendance from "../report/attendance-report/dailyAttendance";
import LockScreen from "../auth/lockScreen";
import EmailVerification2 from "../auth/emailVerification/emailVerification-2";
import EmailVerification3 from "../auth/emailVerification/emailVerification-3";
import NotificationActivities from "../pages/profile/activities";
import Videocallss from "../application/call/videocalls";
import Videocall from "../application/call/videoCall";
import { APP_ROLES } from "../network/auth/Auth";
import AcademyYearGrid from "../academic/academy-year/academy-year-grid";
import AcademyYearList from "../academic/academy-year/academy-year-list";
import AcademyTermGrid from "../academic/academy-term/academy-term-grid";
import AcademyTermList from "../academic/academy-term/academy-term-list";
import SchoolGrid from "../schools/school-grid";
import SchoolList from "../schools/school-list";
import Batches from "../academic/batches";
import Subjects from "../academic/subjects";
import Admissions from "../academic/admission";
import CourseFees from "../academic/course-fees";
import TimeTablePerso from "../academic/time-table";
import Application from "../academic/admission/application";
import ClassRoomDetails from "../academic/class-room/classroomDetails";
import TransportVehicleDetails from "../management/transport/transportVehicleDetails";

const routes = all_routes;

export const publicRoutes = [
  // {
  //   path: "/",
  //   name: "Root",
  //   element: <Navigate to="/login" />,
  //   route: Route,
  // },
  {
    path: routes.adminDashboard,
    element: <AdminDashboard />,
    route: Route,
    role: APP_ROLES.ROLE_ADMIN,
    secure: true,
  },
  {
    path: routes.teacherDashboard,
    element: <TeacherDashboard />,
    route: Route,
    role: APP_ROLES.ROLE_ADMIN,
    secure: true,
  },
  {
    path: routes.studentDashboard,
    element: <StudentDasboard />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.parentDashboard,
    element: <ParentDashboard />,
    route: Route,
    role: APP_ROLES.ROLE_DRIVER,
    secure: true,
  },
  {
    path: routes.studentList,
    element: <StudentList />,
    route: Route,
    role: APP_ROLES.ROLE_ADMIN,
    secure: true,
  },
  {
    path: routes.audioCall,
    element: <AudioCall />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.callHistory,
    element: <CallHistory />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.callHistory,
    element: <CallHistory />,
    route: Route,
    role: "",
    secure: true,
  },

  {
    path: routes.connectedApps,
    element: <ConnectedApps />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.countries,
    element: <Countries />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.blankPage,
    element: <BlankPage />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.calendar,
    element: <Calendar />,
    route: Route,
    role: "",
    secure: true,
  },

  {
    path: routes.membershipplan,
    element: <Membershipplan />,
    secure: true,
  },
  {
    path: routes.membershipAddon,
    element: <MembershipAddon />,
    secure: true,
  },
  {
    path: routes.membershipTransaction,
    element: <MembershipTransaction />,
    secure: true,
  },
  {
    path: routes.notes,
    element: <Notes />,
    secure: true,
  },
  {
    path: routes.countries,
    element: <Countries />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.customFields,
    element: <CustomFields />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.dataTables,
    element: <DataTable />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.tablesBasic,
    element: <BasicTable />,
    route: Route,
    role: "",
    secure: true,
  },

  {
    path: routes.deleteRequest,
    element: <DeleteRequest />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.cities,
    element: <Cities />,
    route: Route,
    role: "",
    secure: true,
  },

  {
    path: routes.accordion,
    element: <Accordion />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.avatar,
    element: <Avatar />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.badges,
    element: <Badges />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.border,
    element: <Borders />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.breadcrums,
    element: <Breadcrumb />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.button,
    element: <Buttons />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.buttonGroup,
    element: <ButtonsGroup />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.cards,
    element: <Cards />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.carousel,
    element: <Carousel />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.colors,
    element: <Colors />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.dropdowns,
    element: <Dropdowns />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.grid,
    element: <Grid />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.images,
    element: <Images />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.lightbox,
    element: <Lightboxes />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.media,
    element: <Media />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.modals,
    element: <Modals />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.navTabs,
    element: <NavTabs />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.offcanvas,
    element: <Offcanvas />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.pagination,
    element: <Pagination />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.popover,
    element: <Popovers />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.rangeSlider,
    element: <RangeSlides />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.progress,
    element: <Progress />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.spinner,
    element: <Spinner />,
    route: Route,
    role: "",
    secure: true,
  },

  {
    path: routes.typography,
    element: <Typography />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.video,
    element: <Video />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.toasts,
    element: <Toasts />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.banIpAddress,
    element: <BanIpAddress />,
    route: Route,
    role: "",
    secure: true,
  },
  // {
  //   path: routes.localization,
  //   element: <Localization />,
  //   route: Route,
  // },
  {
    path: routes.preference,
    element: <Preference />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.todo,
    element: <Todo />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.email,
    element: <Email />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.videoCall,
    element: <Videocall />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.chat,
    element: <Chat />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.pages,
    element: <Pages />,
    route: Route,
    role: "",
    secure: true,
  },

  {
    path: routes.fileManager,
    element: <FileManager />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.faq,
    element: <Faq />,
    route: Route,
    role: "",
    secure: true,
  },

  {
    path: routes.states,
    element: <States />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.testimonials,
    element: <Testimonials />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.clipboard,
    element: <ClipBoard />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.counter,
    element: <Counter />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.dragandDrop,
    element: <DragAndDrop />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.rating,
    element: <Rating />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.stickyNotes,
    element: <Stickynote />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.textEditor,
    element: <TextEditor />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.timeLine,
    element: <Timeline />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.scrollBar,
    element: <Scrollbar />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.apexChat,
    element: <Apexchart />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.featherIcons,
    element: <FeatherIcons />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.falgIcons,
    element: <FeatherIcons />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.fantawesome,
    element: <FontawesomeIcons />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.fantawesome,
    element: <FontawesomeIcons />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.materialIcon,
    element: <MaterialIcons />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.pe7icon,
    element: <PE7Icons />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.simpleLineIcon,
    element: <SimplelineIcons />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.themifyIcon,
    element: <ThemifyIcons />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.typicon,
    element: <TypiconIcons />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.basicInput,
    element: <BasicInputs />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.weatherIcon,
    element: <WeatherIcons />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.checkboxandRadion,
    element: <CheckboxRadios />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.inputGroup,
    element: <InputGroup />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.gridandGutters,
    element: <GridGutters />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.formSelect,
    element: <FormSelect />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.formMask,
    element: <FormMask />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.fileUpload,
    element: <FileUpload />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.horizontalForm,
    element: <FormHorizontal />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.verticalForm,
    element: <FormVertical />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.floatingLable,
    element: <FloatingLabel />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.formValidation,
    element: <FormValidation />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.reactSelect,
    element: <FormSelect2 />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.formWizard,
    element: <FormWizard />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.dataTable,
    element: <DataTables />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.tableBasic,
    element: <TablesBasic />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.iconicIcon,
    element: <IonicIcons />,
    route: Route,
    role: "",
    secure: true,
  },
  // {
  //   path: routes.chart,
  //   element: <ChartJs />,
  //   route: Route,
  // },

  {
    path: routes.placeholder,
    element: <Placeholder />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.sweetalert,
    element: <Alert />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.alert,
    element: <AlertUi />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.tooltip,
    element: <Tooltips />,
    route: Route,
    role: "",
    secure: true,
  },
  {
    path: routes.ribbon,
    element: <Ribbon />,
    route: Route,
    role: "",
    secure: true,
  },

  // Peoples Module
  {
    path: routes.teacherGrid,
    element: <TeacherGrid />,
    secure: true,
    role: APP_ROLES.ROLE_ADMIN,
  },
  {
    path: routes.teacherList,
    element: <TeacherList />,
    secure: true,
    role: APP_ROLES.ROLE_ADMIN,
  },
  {
    path: routes.studentGrid,
    element: <StudentGrid />,
    secure: true,
    role: APP_ROLES.ROLE_ADMIN,
  },

  {
    path: routes.academyYearGrid,
    element: <AcademyYearGrid />,
    secure: true,
    role: APP_ROLES.ROLE_ADMIN,
  },
  {
    path: routes.academyYearList,
    element: <AcademyYearList />,
    secure: true,
    role: APP_ROLES.ROLE_ADMIN,
  },
  {
    path: routes.academyTermGrid,
    element: <AcademyTermGrid />,
    secure: true,
    role: APP_ROLES.ROLE_ADMIN,
  },
  {
    path: routes.academyTermList,
    element: <AcademyTermList />,
    secure: true,
    role: APP_ROLES.ROLE_ADMIN,
  },
  {
    path: routes.schoolGrid,
    element: <SchoolGrid />,
    secure: true,
    role: APP_ROLES.ROLE_ADMIN,
  },
  {
    path: routes.schoolList,
    element: <SchoolList />,
    secure: true,
    role: APP_ROLES.ROLE_ADMIN,
  },
  {
    path: routes.feesMaster,
    element: <FeesMaster />,
    secure: true,
    role: APP_ROLES.ROLE_ADMIN,
  },
  {
    path: routes.classes,
    element: <Classes />,
    secure: true,
    role: APP_ROLES.ROLE_ADMIN,
  },
  {
    path: routes.batches,
    element: <Batches />,
    secure: true,
    role: APP_ROLES.ROLE_ADMIN,
  },
  {
    path: routes.subjects,
    element: <Subjects />,
    secure: true,
    role: APP_ROLES.ROLE_ADMIN,
  },
  {
    path: routes.courseFees,
    element: <CourseFees />,
    secure: true,
    role: APP_ROLES.ROLE_ADMIN,
  },
  {
    path: routes.timeTablePerso,
    element: <TimeTablePerso />,
    secure: true,
    role: APP_ROLES.ROLE_ADMIN,
  },
  {
    path: routes.admissions,
    element: <Admissions />,
    secure: true,
    role: APP_ROLES.ROLE_ADMIN,
  },
  {
    path: routes.application,
    element: <Application />,
    secure: true,
    role: APP_ROLES.ROLE_ADMIN,
  },
  {
    path: routes.studentTimeTable,
    element: <StudentTimeTable />,
    secure: true,
    role: APP_ROLES.ROLE_ADMIN,
  },
  {
    path: routes.studentLeaves,
    element: <StudentLeaves />,
    secure: true,
    role: APP_ROLES.ROLE_ADMIN,

  },
  {
    path: routes.studentResult,
    element: <StudentResult />,
    secure: true,
    role: APP_ROLES.ROLE_ADMIN,

  },
  {
    path: routes.classRoom,
    element: <ClassRoom />,
    secure: true,
    role: APP_ROLES.ROLE_ADMIN,
  },
  {
    path: routes.classRoomDetails,
    element: <ClassRoomDetails />,
    secure: true,
    role: APP_ROLES.ROLE_ADMIN,
  },
  {
    path: routes.addStudent,
    element: <AddStudent />,
    secure: true,
  },
  {
    path: routes.editStudent,
    element: <AddStudent />,
    secure: true,
  },
  {
    path: routes.studentLibrary,
    element: <StudentLibrary />,
    secure: true,
  },
  {
    path: routes.studentDetail,
    element: <StudentDetails />,
    secure: true,
    role: APP_ROLES.ROLE_ADMIN,
  },
  {
    path: routes.studentFees,
    element: <StudentFees />,
    secure: true,
  },


  {
    path: routes.studentPromotion,
    element: <StudentPromotion />,
    secure: true,
  },
  {
    path: routes.AcademicReason,
    element: <AcademicReason />,
    secure: true,
  },
  {
    path: routes.classSyllabus,
    element: <ClassSyllabus />,
    secure: true,
  },
  {
    path: routes.classSubject,
    element: <ClassSubject />,
    secure: true,
  },
  {
    path: routes.classSection,
    element: <ClassSection />,
    secure: true,
  },

  {
    path: routes.classRoutine,
    element: <ClassRoutine />,
    secure: true,
  },
  {
    path: routes.sheduleClasses,
    element: <ScheduleClasses />,
    secure: true,
  },
  {
    path: routes.exam,
    element: <Exam />,
    secure: true,
  },
  {
    path: routes.examSchedule,
    element: <ExamSchedule />,
    secure: true,
  },
  {
    path: routes.grade,
    element: <Grade />,
    secure: true,
  },
  {
    path: routes.staff,
    element: <Staff />,
    secure: true,
  },
  {
    path: routes.departments,
    element: <Departments />,
    secure: true,
  },

  {
    path: routes.classHomeWork,
    element: <ClassHomeWork />,
    secure: true,
  },
  {
    path: routes.examResult,
    element: <ExamResult />,
    secure: true,
  },
  {
    path: routes.examAttendance,
    element: <ExamAttendance />,
    secure: true,
  },

  {
    path: routes.addTeacher,
    element: <TeacherForm />,
    secure: true,
  },
  {
    path: routes.editTeacher,
    element: <TeacherForm />,
    secure: true,
  },
  {
    path: routes.teacherDetails,
    element: <TeacherDetails />,
    secure: true,
  },
  {
    path: routes.teachersRoutine,
    element: <TeachersRoutine />,
    secure: true,
  },
  {
    path: routes.teacherSalary,
    element: <TeacherSalary />,
    secure: true,
  },
  {
    path: routes.teacherLeaves,
    element: <TeacherLeave />,
    secure: true,
  },
  {
    path: routes.teacherLibrary,
    element: <TeacherLibrary />,
    secure: true,
  },
  {
    path: routes.parentGrid,
    element: <ParentGrid />,
    secure: true,
    role: APP_ROLES.ROLE_ADMIN,
  },
  {
    path: routes.parentList,
    element: <ParentList />,
    secure: true,
    role: APP_ROLES.ROLE_ADMIN,
  },
  {
    path: routes.classTimetable,
    element: <ClassTimetable />,
    secure: true,
    role: APP_ROLES.ROLE_ADMIN,
  },
  {
    path: routes.transportVehicle,
    element: <TransportVehicle />,
    secure: true,
    role: APP_ROLES.ROLE_ADMIN,
  },
  {
    path: routes.transportVehicleDetails,
    element: <TransportVehicleDetails />,
    secure: true,
    role: APP_ROLES.ROLE_ADMIN,
  },
  {
    path: routes.payroll,
    element: <Payroll />,
    secure: true,
  },
  {
    path: routes.holidays,
    element: <Holiday />,
    secure: true,
  },
  {
    path: routes.designation,
    element: <Designation />,
    secure: true,
  },
  {
    path: routes.listLeaves,
    element: <ListLeaves />,
    secure: true,
  },
  {
    path: routes.staffDetails,
    element: <StaffDetails />,
    secure: true,
  },
  {
    path: routes.staffPayroll,
    element: <StaffPayRoll />,
    secure: true,
  },
  {
    path: routes.staffLeave,
    element: <StaffLeave />,
    secure: true,
  },

  {
    path: routes.layoutDefault,
    element: <AdminDashboard />,
    secure: true,
  },
  {
    path: routes.layoutMini,
    element: <AdminDashboard />,
    secure: true,
  },
  {
    path: routes.layoutRtl,
    element: <AdminDashboard />,
    secure: true,
  },
  {
    path: routes.layoutBox,
    element: <AdminDashboard />,
    secure: true,
  },
  {
    path: routes.layoutDark,
    element: <AdminDashboard />,
    secure: true,
  },
  {
    path: routes.guardiansGrid,
    element: <GuardianGrid />,
    secure: true,
  },
  {
    path: routes.guardiansList,
    element: <GuardianList />,
    secure: true,
  },
  {
    path: routes.feesGroup,
    element: <FeesGroup />,
    secure: true,
  },
  {
    path: routes.feesType,
    element: <FeesTypes />,
    secure: true,
  },

  {
    path: routes.feesAssign,
    element: <FeesAssign />,
    secure: true,
  },
  {
    path: routes.collectFees,
    element: <CollectFees />,
    secure: true,
  },
  {
    path: routes.libraryMembers,
    element: <LibraryMember />,
    secure: true,
  },
  {
    path: routes.libraryBooks,
    element: <Books />,
    secure: true,
  },
  {
    path: routes.libraryIssueBook,
    element: <IssueBook />,
    secure: true,
  },
  {
    path: routes.libraryReturn,
    element: <ReturnBook />,
    secure: true,
  },
  {
    path: routes.sportsList,
    element: <SportsList />,
    secure: true,
  },
  {
    path: routes.playerList,
    element: <PlayersList />,
    secure: true,
  },
  {
    path: routes.hostelRoom,
    element: <HostelRooms />,
    secure: true,
  },
  {
    path: routes.hostelType,
    element: <HostelType />,
    secure: true,
  },
  {
    path: routes.hostelList,
    element: <HostelList />,
    secure: true,
  },
  {
    path: routes.transportRoutes,
    element: <TransportRoutes />,
    secure: true,
  },
  {
    path: routes.transportAssignVehicle,
    element: <TransportAssignVehicle />,
    secure: true,
  },
  {
    path: routes.transportPickupPoints,
    element: <TransportPickupPoints />,
    secure: true,
  },
  {
    path: routes.transportVehicleDrivers,
    element: <TransportVehicleDrivers />,
    secure: true,
  },
  {
    path: routes.transportVehicle,
    element: <TransportVehicle />,
    secure: true,
  },
  {
    path: routes.approveRequest,
    element: <ApproveRequest />,
    secure: true,
  },
  {
    path: routes.studentAttendance,
    element: <StudentAttendance />,
    secure: true,
  },
  {
    path: routes.teacherAttendance,
    element: <TeacherAttendance />,
    secure: true,
  },

  {
    path: routes.staffAttendance,
    element: <StaffAttendance />,
    secure: true,
  },
  {
    path: routes.staffsAttendance,
    element: <StaffsAttendance />,
    secure: true,
  },
  {
    path: routes.addStaff,
    element: <AddStaff />,
    secure: true,
  },
  {
    path: routes.editStaff,
    element: <EditStaff />,
    secure: true,
  },

  {
    path: routes.accountsIncome,
    element: <AccountsIncome />,
    secure: true,
  },
  {
    path: routes.accountsInvoices,
    element: <AccountsInvoices />,
    secure: true,
  },
  {
    path: routes.accountsTransactions,
    element: <AccountsTransactions />,
    secure: true,
  },
  {
    path: routes.addInvoice,
    element: <AddInvoice />,
    secure: true,
  },
  {
    path: routes.editInvoice,
    element: <EditInvoice />,
    secure: true,
  },
  {
    path: routes.guardiansList,
    element: <GuardianList />,
    secure: true,
  },
  {
    path: routes.expense,
    element: <Expense />,
    secure: true,
  },
  {
    path: routes.expenseCategory,
    element: <ExpensesCategory />,
    secure: true,
  },
  {
    path: routes.invoice,
    element: <Invoice />,
    secure: true,
  },
  {
    path: routes.events,
    element: <Events />,
    secure: true,
  },
  {
    path: routes.noticeBoard,
    element: <NoticeBoard />,
    secure: true,
  },

  //Settings

  {
    path: routes.profilesettings,
    element: <Profilesettings />,
    secure: true,
  },
  {
    path: routes.securitysettings,
    element: <Securitysettings />,
    secure: true,
  },
  {
    path: routes.notificationssettings,
    element: <Notificationssettings />,
    secure: true,
  },
  {
    path: routes.connectedApps,
    element: <ConnectedApps />,
    secure: true,
  },
  {
    path: routes.companySettings,
    element: <CompanySettings />,
    secure: true,
  },
  {
    path: routes.localization,
    element: <Localization />,
    secure: true,
  },
  {
    path: routes.prefixes,
    element: <Prefixes />,
    secure: true,
  },
  {
    path: routes.socialAuthentication,
    element: <Socialauthentication />,
    secure: true,
  },
  {
    path: routes.language,
    element: <Languagesettings />,
    secure: true,
  },
  {
    path: routes.invoiceSettings,
    element: <InvoiceSettings />,
    secure: true,
  },
  {
    path: routes.customFields,
    element: <CustomFields />,
    secure: true,
  },
  {
    path: routes.emailSettings,
    element: <EmailSettings />,
    secure: true,
  },
  {
    path: routes.emailTemplates,
    element: <Emailtemplates />,
    secure: true,
  },
  {
    path: routes.smsSettings,
    element: <SmsSettings />,
    secure: true,
  },
  {
    path: routes.optSettings,
    element: <OtpSettings />,
    secure: true,
  },
  {
    path: routes.gdprCookies,
    element: <GdprCookies />,
    secure: true,
  },

  {
    path: routes.paymentGateways,
    element: <PaymentGateways />,
    secure: true,
  },
  {
    path: routes.taxRates,
    element: <TaxRates />,
    secure: true,
  },
  {
    path: routes.schoolSettings,
    element: <SchoolSettings />,
    secure: true,
  },
  {
    path: routes.religion,
    element: <Religion />,
    secure: true,
  },
  {
    path: routes.storage,
    element: <Storage />,
    secure: true,
  },
  {
    path: routes.rolesPermissions,
    element: <RolesPermissions />,
    secure: true,
  },
  {
    path: routes.permissions,
    element: <Permission />,
    secure: true,
  },
  {
    path: routes.manageusers,
    element: <Manageusers />,
    secure: true,
  },
  {
    path: routes.allBlogs,
    element: <AllBlogs />,
    secure: true,
  },
  {
    path: routes.blogCategories,
    element: <BlogCategories />,
    secure: true,
  },
  {
    path: routes.blogComments,
    element: <BlogComments />,
    secure: true,
  },
  {
    path: routes.blogTags,
    element: <BlogTags />,
    secure: true,
  },
  {
    path: routes.tickets,
    element: <Tickets />,
    secure: true,
  },
  {
    path: routes.ticketGrid,
    element: <TicketGrid />,
    secure: true,
  },
  {
    path: routes.ticketDetails,
    element: <TicketDetails />,
    secure: true,
  },
  {
    path: routes.feesReport,
    element: <FeesReport />,
    secure: true,
  },
  {
    path: routes.leaveReport,
    element: <LeaveReport />,
    secure: true,
  },
  {
    path: routes.gradeReport,
    element: <GradeReport />,
    secure: true,
  },
  {
    path: routes.studentReport,
    element: <StudentReport />,
    secure: true,
  },
  {
    path: routes.classReport,
    element: <ClassReport />,
    secure: true,
  },
  {
    path: routes.attendanceReport,
    element: <AttendanceReport />,
    secure: true,
  },
  {
    path: routes.studentAttendanceType,
    element: <StudentAttendanceType />,
    secure: true,
  },
  {
    path: routes.dailyAttendance,
    element: <DailyAttendance />,
    secure: true,
  },
  {
    path: routes.studentDayWise,
    element: <StudentDayWise />,
    secure: true,
  },
  {
    path: routes.teacherDayWise,
    element: <TeacherDayWise />,
    secure: true,
  },
  {
    path: routes.staffDayWise,
    element: <StaffDayWise />,
    secure: true,
  },
  {
    path: routes.teacherReport,
    element: <TeacherReport />,
    secure: true,
  },
  {
    path: routes.staffReport,
    element: <StaffReport />,
    secure: true,
  },
  {
    path: routes.contactMessages,
    element: <ContactMessages />,
    secure: true,
  },
  {
    path: routes.events,
    element: <Events />,
    secure: true,
  },
  {
    path: routes.profile,
    element: <Profile />,
    secure: true,
  },
  {
    path: routes.activity,
    element: <NotificationActivities />,
    secure: true,
  },
];

export const authRoutes = [
  {
    path: routes.comingSoon,
    element: <ComingSoon />,
    route: Route,
    role: "",
    secure: false,
  },
  {
    path: routes.login,
    element: <Login />,
    route: Route,
    role: "",
    secure: false,
  },
  {
    path: routes.login2,
    element: <Login2 />,
    route: Route,
    role: "",
    secure: false,
  },
  {
    path: routes.login3,
    element: <Login3 />,
    route: Route,
    role: "",
    secure: false,
  },
  {
    path: routes.register,
    element: <Register />,
    route: Route,
    role: "",
    secure: false,
  },
  {
    path: routes.twoStepVerification,
    element: <TwoStepVerification />,
    route: Route,
    role: "",
    secure: false,
  },
  {
    path: routes.twoStepVerification2,
    element: <TwoStepVerification2 />,
    route: Route,
    role: "",
    secure: false,
  },
  {
    path: routes.twoStepVerification3,
    element: <TwoStepVerification3 />,
    route: Route,
    role: "",
    secure: false,
  },
  {
    path: routes.emailVerification,
    element: <EmailVerification />,
    route: Route,
    role: "",
    secure: false,
  },
  {
    path: routes.emailVerification2,
    element: <EmailVerification2 />,
    route: Route,
    role: "",
    secure: false,
  },
  {
    path: routes.emailVerification3,
    element: <EmailVerification3 />,
    route: Route,
    role: "",
    secure: false,
  },
  {
    path: routes.register,
    element: <Register />,
    route: Route,
    role: "",
    secure: false,
  },
  {
    path: routes.register2,
    element: <Register2 />,
    route: Route,
    role: "",
    secure: false,
  },
  {
    path: routes.register3,
    element: <Register3 />,
    route: Route,
    role: "",
    secure: false,
  },
  {
    path: routes.resetPassword,
    element: <ResetPassword />,
    route: Route,
    role: "",
    secure: false,
  },
  {
    path: routes.resetPassword2,
    element: <ResetPassword2 />,
    route: Route,
    role: "",
    secure: false,
  },
  {
    path: routes.resetPassword3,
    element: <ResetPassword3 />,
    route: Route,
    role: "",
    secure: false,
  },
  {
    path: routes.forgotPassword,
    element: <ForgotPassword />,
    route: Route,
    role: "",
    secure: false,
  },
  {
    path: routes.forgotPassword2,
    element: <ForgotPassword2 />,
    route: Route,
    role: "",
    secure: false,
  },
  {
    path: routes.forgotPassword3,
    element: <ForgotPassword3 />,
    route: Route,
    role: "",
    secure: false,
  },
  {
    path: routes.error404,
    element: <Error404 />,
    route: Route,
    role: "",
    secure: false,
  },
  {
    path: routes.error500,
    element: <Error500 />,
    route: Route,
    role: "",
    secure: false,
  },
  {
    path: routes.underMaintenance,
    element: <UnderMaintenance />,
    route: Route,
    role: "",
    secure: false,
  },
  {
    path: routes.lockScreen,
    element: <LockScreen />,
    secure: false,
  },
  {
    path: routes.resetPasswordSuccess,
    element: <ResetPasswordSuccess />,
    secure: false,
  },
  {
    path: routes.resetPasswordSuccess2,
    element: <ResetPasswordSuccess2 />,
    secure: false,
  },
  {
    path: routes.resetPasswordSuccess3,
    element: <ResetPasswordSuccess3 />,
    secure: false,
  },
];
